module.exports = __webpack_public_path__ + "static/media/phonemeIsolation-starter-intro.a27409e4.mp3";